import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
	mutation createAADOauthKeyMutation($input: CreateAADOauthKeyInput!) {
		createAADOauthKey(input: $input) {
			key
			AADClientId
			AADTenant
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input};
	return commitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
